import { AuthenticatorConfig } from '../interfaces/authenticator.interface';

export const AUTHENTICATOR_CONFIG: AuthenticatorConfig = {
  codeLength: 6,
};

export const LOGIN_OPTIONS = {
  width: '600px',
  maxWidth: '95vw',
  panelClass: 'no-radius-dialog',
};
